// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'

import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/store'
import VueCookie from 'vue-cookie'
import { mapState, mapGetters, mapMutations } from 'vuex'
import Vuelidate from 'vuelidate'
// import GAuth from 'vue-google-oauth2'

// Vue.use(GAuth, {clientId: process.env.GOOGLE_CLIENTID, scope: 'profile email'})
Vue.use(Vuelidate)
Vue.use(VueCookie)
Vue.config.productionTip = false
// FIXME: Comment away cookies

// HTTP Interceptors
Vue.http.interceptors.push(function (request, next) {
  // REF: https://stackoverflow.com/questions/39665244/vue-resource-interceptor-for-auth-headers
  // modify headers
  request.headers.set('Content-Type', 'application/json')
  request.headers.set('Accept', 'application/json')
  request.headers.set('Cache-Control', 'no-cache, no-store')
  request.headers.set('x-auth-token', store.state.userAuthToken)
  next()
})

router.beforeResolve((to, from, next) => {
  if (store.state.userAuthToken !== null && store.state.userId !== null && store.state.userEmail !== null) {
    window.scrollTo(0, 0)
    next()
    // TODO: Comment this line when in producction
  // } else if (Vue.cookie.get('userAuthToken') !== null && Vue.cookie.get('userId') !== null) {
  //   store.dispatch('updateUserProfile', {
  //     userAuthToken: Vue.cookie.get('userAuthToken'),
  //     userId: Vue.cookie.get('userId')
  //   })
  //   next()
  } else if (to.name === 'Login') {
    // Note: This block is to prevent infinite loop on Login page
    next()
  } else {
    next({ name: 'Login'})
  }
})

Vue.mixin({
  computed: {
    ...mapState(['userAuthToken', 'userEmail', 'userId']),
    ...mapGetters(['localization'])
  },
  methods: {
    ...mapMutations(['unsetStore']),
    clearAllSessionData: function (params) {
      this.$cookie.delete('userAuthToken')
      this.$cookie.delete('userId')
      this.$cookie.delete('userEmail')
      this.unsetStore()
      this.$router.push({ name: 'Login', params: params })
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  store: store
})



// WEBPACK FOOTER //
// ./src/main.js